import styled from "styled-components"
import {Col, Row} from "react-bootstrap"

import Hr from "@irati/ui/src/Layout/Hr"
import Button from "@irati/ui/src/Button"
import media from "@irati/ui/src/global/media"
import {greys} from "@irati/ui/src/global/colors"
import {Para} from "@irati/ui/src/Labels"
import BrandAvatar from "@irati/ui/src/BrandAvatar"
import {Body} from "@irati/ui/src/Typography"

export const ItemContainer = styled.div`
  padding: 5px;
  border-radius: 5px;
  ${({addGreyBackground}) => (addGreyBackground && `background-color: ${greys.light};`)}
  ${media.tablet`
    padding: 10px 5px;
  `}
`

export const HrOnlyMobile = styled(Hr)`
  display: none;

  ${media.tablet`
    display: block;
    margin: 15px 0;
  `}
`

export const StyledHr = styled(Hr)`
  border-color: ${({theme}) => theme.colors.greys.medium};
`

export const LogoWrapper = styled.div`
  text-align: center;
  margin-left: 5px;
  float: left;
   ${media.tablet`
      padding-top: 0;
  `}
`

export const DealAvatar = styled(BrandAvatar)`
  width: 80px;
  height: 80px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    width: 60px;
    height: 60px;
  `}

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    width: 80px;
    height: 80px;
  `}
`

export const MobileQty = styled(Body)`
  display: none;

  ${media.tablet`
    display: block;
  `}
`
export const StyledButton = styled(Button)`
  margin: 10px 0 0;
`

export const StyledRow = styled(Row)`
  display: flex;
  align-items: center;
`

export const StyledPara = styled(Para)`
  margin: 5px 0;
`

export const StyledDeleteHeaderCol = styled(Col)`
  margin-left: 5px;
`

export const StyledDeleteButtonCol = styled(Col)`
  position: absolute;
  bottom: 5px;
  right: 0px;
`
